// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

const maybeNullString = anyOf(nullOrUndefined, string);

// Rows carry the object's schema attributes too (spread by the backend serializer), so only the
// fields the consumers rely on are validated.
const isUnlinkedObjectRow = objectOf({
  id: string,
  object_id: string,
  display_name: maybeNullString,
});

export const isCustomObjectsTypeNameObjectIdUnlinkedObjectsResponse = objectOf({
  hits: number,
  results: arrayOf(isUnlinkedObjectRow),
});
